/**
 * 越南语
 */
export default {
  // 菜单路由
  route: {
    dashboard: {
      _name: 'Bảng điều khiển',
      workplace: {_name: 'Bàn làm việc'},
      analysis: {_name: 'Trang phân tích'},
      monitor: {_name: '监控页'}
    },

    system: {
      _name: 'Quản lý tài khoản',
      admin: {_name: 'Quản lý danh sách'},
      finance: {_name: 'Danh sách tài chính'},
      role: {_name: 'Quản lý vai trò'},
      user: {_name: 'Quản lý người dùng'}
    },

    resource: {
      _name: 'Quản lý nguồn tài nguyên',
      class: {_name: 'Nhận nhóm thẻ ngân hàng'},
      recolumn: {_name: 'Danh sách thẻ ngân hàng'}
    },

    reconciliation: {
      _name: 'Quản lý nguồn tài nguyên',
      bankrecords: {_name: 'Sao kê thẻ ngân hàng'},
      bussiness: {_name: 'đối chiếu người dùng'},
      channel: {_name: 'đối chiếu kênh'},
      model: {_name: 'hòa giải trận đấu'},
      shouyi: {_name: 'Lợi nhuận hệ thống'},
      bank: {_name: 'đối chiếu thẻ ngân hàng'}  
    },

    wallet: {
      _name: 'Quản lý ví',
      currency: {_name: 'Quản lý tiền tệ'},
      transmodel: {_name: 'Mô hình giao dịch'}
    },

    balance: {
      _name: 'Điều chỉnh số dư người dùng',
      index: {_name: 'Điều chỉnh số dư người dùng'}
    },

    channel: {
      _name: 'Quản lí kênh',
      type: {_name: 'Loại kênh'},
      balance: {_name: 'Cân bằng kênh'},
      column: {_name: 'Danh sách kênh'}
    },
    
    user: {
      _name: 'Thiết lập cá nhân',
      profile: {_name: 'Thông tin cá nhân'},
      message: {_name: '我的消息'}
    },

    transaction: {
      _name: 'Thiết lập cá nhân',
      inorder: {_name: 'Lệnh thanh toán'},
      inlist: {_name: 'Xác nhận thanh toán'},
      outorder: {_name: 'đặt hàng trước để thanh toán'},
      records: {_name: 'Thay đổi kinh phí'}
    },

    config: {
      _name: 'Cài đặt hệ thống',
      website: {_name: 'Cài đặt hệ thống'},
      menu: {_name: 'quản lý thực đơn'}
    },






    form: {
      _name: '表单页面',
      basic: {_name: '基础表单'},
      advanced: {_name: '复杂表单'},
      step: {_name: '分步表单'}
    },
    list: {
      _name: '列表页面',
      basic: {_name: '基础列表'},
      advanced: {_name: '复杂列表'},
      card: {
        _name: '卡片列表',
        project: {_name: '项目列表'},
        application: {_name: '应用列表'},
        article: {_name: '文章列表'}
      }
    },
    result: {
      _name: '结果页面',
      success: {_name: '成功页'},
      fail: {_name: '失败页'}
    },
    exception: {
      _name: '异常页面',
      '403': {_name: '403'},
      '404': {_name: '404'},
      '500': {_name: '500'}
    },
    
    extension: {
      _name: '扩展组件',
      icon: {_name: '字体图标'},
      file: {_name: '文件列表'},
      printer: {_name: '打印插件'},
      excel: {_name: 'excel插件'},
      dragsort: {_name: '拖拽排序'},
      map: {_name: '地图组件'},
      player: {_name: '视频播放'},
      editor: {_name: '富文本框'},
      more: {_name: '更多组件'}
    },
    example: {
      _name: '经典实例',
      document: {_name: '案卷调整'},
      choose: {_name: '批量选择'},
    },
    'http://www.xxx.com': {_name: '获取授权'}
  },
  // 主框架
  layout: {
    home: '主页',
    header: {
      profile: '个人中心',
      password: '修改密码',
      logout: '退出登录'
    },
    footer: {
      website: '官网',
      document: '文档',
      authorization: '授权',
      copyright: 'Copyright © 2021 南京RXThinkCMF研发中心'
    },
    logout: {
      title: '提示',
      message: '确定要退出登录吗?'
    }
  },
  // 登录界面
  login: {
    title: 'Nền quản trị - Đăng nhập',
    username: 'Đăng nhập tài khoản',
    password: 'Mật khẩu đăng nhập',
    captcha: 'Mã xác nhận',
    remember: 'Nhớ mật khẩu',
    forget: 'Quên mật khẩu',
    login: 'Đăng nhập',
    loading: 'Đăng nhập'
  },
    // 首页
    home:{
      totalbalance:"总余额",
      availablebalance:"可用余额",
      freezebalance:"冻结金额",
      unsettledamount:"未结算余额",
    },
    // 清理数据
    cleandata:{
      selecttime:"kỳ tuyển chọn",
      startingtime:"Thời gian bắt đầu",
      endtime:"Thời gian kết thúc",
      selectdata:"Chọn dữ liệu",
      choose:"xin vui lòng chọn",
      option1:"[Tất cả dữ liệu] | Hãy lựa chọn cẩn thận, sau khi xóa sẽ không thể phục hồi được.",
      option2:"[Dữ liệu thanh toán] | Hãy lựa chọn cẩn thận, sau khi xóa sẽ không thể phục hồi được.",
      option3:"[Dữ liệu rút tiền] | Hãy lựa chọn cẩn thận, không thể khôi phục sau khi xóa.",
      option4:"[Dữ liệu thay đổi tài khoản] | Hãy lựa chọn cẩn thận, không thể khôi phục sau khi xóa.",
      warnings: "Mẹo: Vui lòng xóa một cách thận trọng, nó không thể được khôi phục sau khi thao tác.",
      recognize: "Chắc chắn"
    }
}
